import { render, staticRenderFns } from "./ResourceStatusCard.vue?vue&type=template&id=18ecfdaa&"
import script from "./ResourceStatusCard.vue?vue&type=script&lang=js&"
export * from "./ResourceStatusCard.vue?vue&type=script&lang=js&"
import style0 from "./ResourceStatusCard.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports